<template>
  <v-container fluid>
    <material-card icon="mdi-google-classroom" title="Online Class">
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'scheduleOnlineClass' }">
          <v-btn color="accent" v-if="isWrite" elevation="1" absolute right top>
            <v-icon left>mdi-plus</v-icon>Schedule Class
          </v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="pb-4">
        <v-card-text>
          <v-tabs v-model="tab">
            <v-tab key="Upcoming Classes">
              Upcoming Classes
            </v-tab>
            <v-tab key="Previous Classes">
              Previous Classes
            </v-tab>
            <v-tab key="Cancelled Classes">
              Cancelled Classes
            </v-tab>
          </v-tabs>
          <v-divider class="my-0"></v-divider>
        </v-card-text>

        <v-tabs-items v-model="tab">
          <v-tab-item key="Upcomming Classes">
            <v-card>
              <!--Filter Section Start -->
              <v-row>
                <v-col cols="4" md="4">
                  <label class="label">From </label>
                  <div class="control">
                    <input class="input" type="date" v-model="upcoming_fromDate"
                      v-on:change="getAllMeetings()" required />
                  </div>

                </v-col>
                <v-col cols="4" md="4">

                  <label class="label">To </label>
                  <div class="control">
                    <input class="input" v-on:change="getAllMeetings()" type="date"
                      v-model="upcoming_toDate" required />
                  </div>
                </v-col>
                <v-col cols="4" md="4">
                  <v-text-field
                    :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                    v-model="upcoming_search" @input="searchData" append-icon="mdi-magnify"
                    class="ml-auto mb-2" label="Search" hide-details single-line
                    style="max-width:350px; margin-top: 20px" />
                </v-col>
              </v-row>
              <!--Filter Section End -->
              <v-data-table :headers="upcommingClassHeaders" :items="upComingClasses"
                disable-pagination :hide-default-footer="true">
                <template v-slot:item.id="{ item }">
                  {{
                    upComingClasses
                      .map(function(x) {
                        return x.id
                      })
                      .indexOf(item.id) + 1
                  }}
                </template>

                <template v-slot:item.action="{ item }" v-if="!this.isStudent">
                  <v-btn class="px-2 ml-1 white--text ma-1" outlined color="success" x-small
                    @click="sendNotification(item.id)" :disabled="item.disableAction">
                    <!-- <v-icon left> mdi-email-alert</v-icon> -->
                    Send Email
                  </v-btn>
                  <v-btn class="px-2 ml-1 white--text ma-1" x-small outlined color="error"
                    @click="cancelMeetingDialogOpen(item.id)" :disabled="item.disableAction">
                    <!-- <v-icon left> mdi-cancel</v-icon> -->
                    Cancel
                  </v-btn>
                </template>

                <template v-slot:item.join="{ item }">
                  <v-btn small outlined @click="JoinMeeting(item.id)"
                    :disabled="item.isDisableJoinMeeting" color="primary" elevation="1">
                    <!-- <v-icon left> mdi-message-video</v-icon> -->
                    {{ item.join }}
                  </v-btn>
                  <v-btn small outlined @click="endMeeting(item.id)"
                    v-if="item.displayEndMeetingButton" color="red" elevation="1">
                    <v-icon small> mdi-message-video</v-icon>
                    End Class
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
              </v-data-table>
              <!--Pagination for upcoming records start-->
              <v-row>
                <v-col cols="4" sm="3">
                  <v-select v-model="pageSize_upcoming" :items="pageSizes" label="Items per Page"
                    @change="handlePageSizeChange_upcoming"></v-select>
                </v-col>
                <v-col cols="12" sm="9">
                  <v-pagination v-model="page_upcoming" :length="totalPages_upcoming"
                    :total-visible="totalPages_upcoming" @input="handlePageChange_upcoming">
                  </v-pagination>
                </v-col>
              </v-row>
              <!--Pagination for upcoming records end-->
            </v-card>
          </v-tab-item>

          <v-tab-item key="Previous Classes">
            <v-card>
              <!--Filter Section Start -->
              <v-row>
                <v-col cols="4" md="4">
                  <label class="label">From </label>
                  <div class="control">
                    <input class="input" type="date" v-model="previous_fromDate"
                      v-on:change="getAllMeetings()" required />
                  </div>

                </v-col>
                <v-col cols="4" md="4">

                  <label class="label">To </label>
                  <div class="control">
                    <input class="input" v-on:change="getAllMeetings()" type="date"
                      v-model="previous_toDate" required />
                  </div>
                </v-col>
                <v-col cols="4" md="4">
                  <v-text-field
                    :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                    v-model="previous_search" @input="searchData" append-icon="mdi-magnify"
                    class="ml-auto mb-2" label="Search" hide-details single-line
                    style="max-width:350px; margin-top: 20px" />
                </v-col>
              </v-row>
              <!--Filter Section End -->
              <v-data-table :headers="PreviousClassHeaders" :items="previousClasses"
                disable-pagination :hide-default-footer="true">
                <template v-slot:item.id="{ item }">
                  {{
                    previousClasses
                      .map(function(x) {
                        return x.id
                      })
                      .indexOf(item.id) + 1
                  }}
                </template>
                <template v-slot:item.download="{ item }">
                  <div v-if="item.recordingURL">
                  <!-- <v-btn v-if="item.metaOk" @click="openRecording(item.recordingURL)" :disabled="item.showDownload" color="green" elevation="1"> -->
                  <v-btn @click="openRecording(item.recordingURL)" :disabled="item.showDownload" color="green" elevation="1">
                    <v-icon small> mdi-record-circle-outline</v-icon>
                     View Recording
                  </v-btn>
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
                <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
              </v-data-table>
              <!--Pagination for previous records start-->
              <v-row>
                <v-col cols="4" sm="3">
                  <v-select v-model="pageSize_previous" :items="pageSizes" label="Items per Page"
                    @change="handlePageSizeChange_previous"></v-select>
                </v-col>
                <v-col cols="12" sm="9">
                  <v-pagination v-model="page_previous" :length="totalPages_previous"
                    :total-visible="totalPages_previous" @input="handlePageChange_previous">
                  </v-pagination>
                </v-col>
              </v-row>
              <!--Pagination for previous records end-->
            </v-card>
          </v-tab-item>

          <v-tab-item key="Cancelled Classes">
            <v-card>
              <!--Filter Section Start -->
              <v-row>
                <v-col cols="4" md="4">
                  <label class="label">From </label>
                  <div class="control">
                    <input class="input" type="date" v-model="cancel_fromDate"
                      v-on:change="getAllMeetings()" required />
                  </div>

                </v-col>
                <v-col cols="4" md="4">

                  <label class="label">To </label>
                  <div class="control">
                    <input class="input" v-on:change="getAllMeetings()" type="date"
                      v-model="cancel_toDate" required />
                  </div>
                </v-col>
                <v-col cols="4" md="4">
                  <v-text-field
                    :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                    v-model="cancel_search" @input="searchData" append-icon="mdi-magnify"
                    class="ml-auto mb-2" label="Search" hide-details single-line
                    style="max-width:350px; margin-top: 20px" />
                </v-col>
              </v-row>
              <!--Filter Section End -->
              <v-data-table :headers="CancelledClassHeaders" :items="cancelledClasses"
                disable-pagination :hide-default-footer="true">
                <template v-slot:item.id="{ item }">
                  {{
                    cancelledClasses
                      .map(function(x) {
                        return x.id
                      })
                      .indexOf(item.id) + 1
                  }}
                </template>
                <template v-slot:item.action="{ item }" v-if="!this.isStudent">
                  <v-btn class="px-2 ml-1 white--text ma-1" outlined color="success" x-small
                    @click="sendCancelledNotification(item.id)">
                    Send Email
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
              </v-data-table>
              <!--Pagination for cancel records start-->
              <v-row>
                <v-col cols="4" sm="3">
                  <v-select v-model="pageSize_cancel" :items="pageSizes" label="Items per Page"
                    @change="handlePageSizeChange_cancel"></v-select>
                </v-col>
                <v-col cols="12" sm="9">
                  <v-pagination v-model="page_cancel" :length="totalPages_cancel"
                    :total-visible="totalPages_cancel" @input="handlePageChange_cancel">
                  </v-pagination>
                </v-col>
              </v-row>
              <!--Pagination for cancel records end-->
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-dialog max-width="500px" v-model="openCancelDialog">
        <v-card>
          <v-card-title>
            <span class="headline">{{ cancelMeetings.meetingName }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field label="Class Time" readonly v-model="cancelMeetings.meetingTime">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field label="Cancellation Reason" :error-messages="nameErrors" required
                    v-model="cancelMeetings.reason"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="cancelMeeting">
              Cancel Class
            </v-btn>
            <v-btn color="primary" text @click="openCancelDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </material-card>
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
const defaultPage = 1
const defaultSize = 10
const fromDate = moment().subtract(1, 'month').format('YYYY-MM-DD')
const toDate = moment().format('YYYY-MM-DD')
export default {
  name: 'OnlineClassList',
  components: { MaterialCard },
  data () {
    return {
      upcoming_fromDate: fromDate,
      upcoming_toDate: toDate,
      cancel_fromDate: fromDate,
      cancel_toDate: toDate,
      previous_fromDate: fromDate,
      previous_toDate: toDate,
      page_upcoming: defaultPage,
      totalPages_upcoming: 0,
      totalRecords_upcoming: 0,
      pageSize_upcoming: defaultSize,
      page_previous: defaultPage,
      totalPages_previous: 0,
      totalRecords_previous: 0,
      pageSize_previous: defaultSize,
      page_cancel: defaultPage,
      totalPages_cancel: 0,
      totalRecords_cancel: 0,
      pageSize_cancel: defaultSize,
      upcoming_search: '',
      cancel_search: '',
      previous_search: '',
      pageSizes: [5, 10, 20],
      searchTimer: null,
      upCommingClassHeaders: [],
      PreviousClassHeaders: [
        { text: 'Sr.No', value: 'id' },
        { text: 'Class/Section', value: 'classSection' },
        { text: 'name', value: 'name' },
        { text: 'meetingTime', value: 'meetingDateTime' },
        { text: 'Duration', value: 'duration' },
        { text: 'Description', value: 'description' },
        { text: 'Join Student Count', value: 'JoinStudentCount' },
        { text: 'CreatedBy', value: 'createdBy' },
        { text: 'View Recordings', value: 'download' }
      ],
      cancelledClassHeaders: [],
      meetingList: [],
      franchiseeList: [],
      academicYearList: [],
      academicYearID: '',
      franchiseeID: '',
      cancelMeetings: {
        id: '',
        meetingName: '',
        meetingTime: '',
        reason: ''
      },
      openCancelDialog: false,
      tab: null,
      inProgress: false,
      upComingClasses: [],
      previousClasses: [],
      cancelledClasses: [],
      loadingComponent: null,
      isWrite: false,
      nameErrors: '',
      isStudent: ''
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    upcommingClassHeaders () {
      if (this.isStudent) {
        return [
          { text: 'Sr.No', value: 'id' },
          { text: 'Class/Section', value: 'classSection' },
          { text: 'name', value: 'name' },
          { text: 'meetingTime', sortable: false, value: 'meetingDateTime' },
          { text: 'Duration', sortable: false, value: 'duration' },
          { text: 'Description', sortable: false, value: 'description' },
          { text: 'CreatedBy', value: 'createdBy' },
          { text: 'Join', sortable: false, value: 'join' }
        ]
      } else {
        return [
          { text: 'Sr.No', value: 'id' },
          { text: 'Class/Section', value: 'classSection' },
          { text: 'name', value: 'name' },
          { text: 'meetingTime', sortable: false, value: 'meetingDateTime' },
          { text: 'Duration', sortable: false, value: 'duration' },
          { text: 'Description', sortable: false, value: 'description' },
          { text: 'CreatedBy', value: 'createdBy' },
          { text: 'Action', sortable: false, value: 'action' },
          { text: 'Join', sortable: false, value: 'join' }
        ]
      }
    },
    CancelledClassHeaders () {
      if (this.isStudent) {
        return [
          { text: 'Sr.No', sortable: false, value: 'id' },
          { text: 'Class-Section', sortable: false, value: 'classSection' },
          { text: 'name', sortable: false, value: 'name' },
          { text: 'meetingTime', sortable: false, value: 'meetingDateTime' },
          { text: 'Duration', sortable: false, value: 'duration' },
          { text: 'Description', sortable: false, value: 'description' },
          { text: 'CreatedBy', sortable: false, value: 'createdBy' }
        ]
      } else {
        return [
          { text: 'Sr.No', sortable: false, value: 'id' },
          { text: 'Class-Section', sortable: false, value: 'classSection' },
          { text: 'name', sortable: false, value: 'name' },
          { text: 'meetingTime', sortable: false, value: 'meetingDateTime' },
          { text: 'Duration', sortable: false, value: 'duration' },
          { text: 'Description', sortable: false, value: 'description' },
          { text: 'CreatedBy', sortable: false, value: 'createdBy' },
          { text: 'Action', sortable: false, value: 'action' }
        ]
      }
    }
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      this.isWrite = await Utils.helper.getIsWriteFun(this.$route)
      this.isLoading = true
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = await Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      await this.onFranchiseeChange()
      this.academicYearID = academicYear ? academicYear.id : ''
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    openRecording (url) {
      window.open(url)
    },
    searchData () {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      let that = this
      this.searchTimer = setTimeout(() => {
        that.getAllMeetings()
      }, 500)
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          if (!this.franchiseeID) {
            Utils.helper.openDrawer(this)
          } else {
            Utils.helper.openDrawer(this, false)
          }
          if (this.franchiseeID && this.academicYearID) {
            await this.onStart()
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    onStart: async function () {
      try {
        await this.getAllMeetings()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.franchiseeList = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getAllMeetings: async function () {
      try {
        if (!this.franchiseeID) {
          return this.errMsg('Please Select a franchisee')
        }
        if (!this.academicYearID) {
          return
        }

        // this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/online-meeting/get-all-pagination`, {
          params: {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYearID,
            page_upcoming: this.page_upcoming,
            size_upcoming: this.pageSize_upcoming,
            page_previous: this.page_previous,
            size_previous: this.pageSize_previous,
            page_cancel: this.page_cancel,
            size_cancel: this.pageSize_cancel,
            upcoming_search: this.upcoming_search || null,
            cancel_search: this.cancel_search || null,
            previous_search: this.previous_search || null,
            upcoming_fromDate: this.upcoming_fromDate,
            upcoming_toDate: this.upcoming_toDate,
            cancel_fromDate: this.cancel_fromDate,
            cancel_toDate: this.cancel_toDate,
            previous_fromDate: this.previous_fromDate,
            previous_toDate: this.previous_toDate
          }
        })

        if (data) {
          this.pageSizeCalculation(data)
          this.upComingClasses = data.upComingClasses
          _.forEach(this.upComingClasses, (row) => {
            if (_.isEqual(row.join, 'Join Class')) {
              let meetingStartTime = moment(row.meetingDateTime)
              let currentTime = moment().format()
              row.timeDifference = moment(meetingStartTime).diff(currentTime, 'minutes')
              if (row.timeDifference <= 30) {
                row.timeLeft = row.timeDifference
                if (row.timeLeft >= 10) {
                  row.setInterval = setInterval(() => {
                    if (row.timeLeft <= 10) {
                      row.isDisableJoinMeeting = false
                      // clearInterval(row.setInterval)
                    }
                    if (row.timeLeft <= 1) {
                      row.disableAction = true
                    }
                    row.timeLeft = row.timeLeft - 1
                  }, 1000 * 60)
                }
              }
            }
          })
          this.isStudent = data.isStudent
          this.previousClasses = data.previousClasses
          this.cancelledClasses = data.cancelledClasses
          let todayDate = new Date()
          this.previousClasses.map((a) => {
            a.showDownload = a.meetingDateTime > todayDate
          })
          // _.map(this.previousClasses, a => {
          //   this.checkMeta(a.bigBlueButtonID).then(x => {
          //     a.metaOk = x
          //   }).catch(e => {
          //     const errorMessage = (e && e.response && e.response.data.message) || e.message
          //     return this.errMsg(errorMessage)
          //   })
          // })

          if (this.isStudent) {
            this.upCommingClassHeaders = _.filter(this.upCommingClassHeader, (obj) => obj.text !== 'Action')
            this.cancelledClassHeaders = _.filter(this.cancelledClassHeader, (obj) => obj.text !== 'Action')
            console.log('this.upCommingClassHeaders', this.upCommingClassHeaders)
          }
        }
      } catch (e) {
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.toast.open({
          type: 'is-danger',
          message: errorMessage,
          duration: 3000
        })
      } finally {
        // this.loadingComponent.close()
      }
    },
    checkMeta: async function (id) {
      try {
        let parser = new DOMParser()
        let rez = await fetch(`https://fcintellistarblobstorage.blob.core.windows.net/intellitot-video-classes/${id}/metadata.xml`)
        let data = await rez.text()
        let xmlDoc = await parser.parseFromString(data, 'text/xml')
        let t = xmlDoc.getElementsByTagName('id')[0]
        return !!t
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error', errorMessage)
        // return this.errMsg(errorMessage)
      }
    },
    sendNotification: async function (meetingID) {
      try {
        if (meetingID) {
          const meeting = this.upComingClasses.find((obj) => obj.id === meetingID)
          if (!meeting) {
            return this.errMsg('Class Not found!')
          }
          this.loadingComponent = this.$buefy.loading.open()
          await http.get(`${constants.API_URL}/api/online-meeting/send-notification?meetingID=${meetingID}`)
          this.loadingComponent.close()
          return this.okMsg('Notification sent successfully!')
        }
      } catch (e) {
        this.loadingComponent.close()
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    sendCancelledNotification: async function (meetingID) {
      try {
        if (meetingID) {
          const meeting = this.cancelledClasses.find((obj) => obj.id === meetingID)
          if (!meeting) {
            return this.errMsg('Class Not found!')
          }
          this.loadingComponent = this.$buefy.loading.open()
          await http.get(`${constants.API_URL}/api/online-meeting/cancelled-class-notification?meetingID=${meetingID}`)
          this.loadingComponent.close()
          return this.okMsg('Notification sent successfully!')
        }
      } catch (e) {
        this.loadingComponent.close()
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    cancelMeetingDialogOpen: async function (meetingID) {
      const meeting = this.upComingClasses.find((obj) => obj.id === meetingID)
      this.nameErrors = ''
      this.cancelMeetings = {
        id: meetingID,
        meetingName: meeting.name,
        meetingTime: meeting.meetingDateTime,
        reason: ''
      }
      this.openCancelDialog = !this.openCancelDialog
    },
    cancelMeeting: async function () {
      try {
        if (!this.cancelMeetings.reason) {
          this.nameErrors = 'Please provide class cancellation reason'
          return
        }
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(`${constants.API_URL}/api/online-meeting/cancel?meetingID=${this.cancelMeetings.id}&&reason=${this.cancelMeetings.reason}`)
        this.loadingComponent.close()
        this.openCancelDialog = false
        await this.getAllMeetings()
      } catch (e) {
        this.loadingComponent.close()
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    JoinMeeting: async function (meetingID) {
      try {
        if (meetingID) {
          const meeting = this.upComingClasses.find((obj) => obj.id === meetingID)
          if (!meeting) {
            return this.errMsg('Class Not found!')
          }
          this.loadingComponent = this.$buefy.loading.open()
          const { data } = await http.get(`${constants.API_URL}/api/online-meeting/get-url?meetingID=${meetingID}`)
          this.loadingComponent.close()
          if (data) {
            this.$router.push({ name: 'joinMeeting', params: { referenceID: data.referenceID } })
          }
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    endMeeting: async function (meetingID) {
      try {
        if (meetingID) {
          const meeting = this.upComingClasses.find((obj) => obj.id === meetingID)
          if (!meeting) {
            return this.errMsg('Class Not found!')
          }
          this.loadingComponent = this.$buefy.loading.open()
          await http.get(`${constants.API_URL}/api/online-meeting/end?meetingID=${meetingID}`)
          this.loadingComponent.close()
          this.getAllMeetings()
          return this.okMsg('Class ended successfully!')
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    pageSizeCalculation (data) {
      this.totalRecords_upcoming = data.upComingClasses_totalRecords
      this.totalRecords_previous = data.previousClasses_totalRecords
      this.totalRecords_cancel = data.cancelledClasses_totalRecords
      this.totalPages_upcoming = Math.ceil(this.totalRecords_upcoming / this.pageSize_upcoming)
      this.totalPages_previous = Math.ceil(this.totalRecords_previous / this.pageSize_previous)
      this.totalPages_cancel = Math.ceil(this.totalRecords_cancel / this.pageSize_cancel)

      if (
        !(
          (this.page_upcoming <= this.totalPages_upcoming || this.totalPages_upcoming === 0) &&
          (this.page_previous <= this.totalPages_previous || this.totalPages_previous === 0) &&
          (this.page_cancel <= this.totalPages_cancel || this.totalPages_cancel === 0)
        )
      ) {
        this.page_upcoming = this.page_upcoming <= this.totalPages_upcoming ? this.page_upcoming : 1
        this.page_previous = this.page_previous <= this.totalPages_previous ? this.page_previous : 1
        this.page_cancel = this.page_cancel <= this.totalPages_cancel ? this.page_cancel : 1
        this.getAllMeetings()
      }
    },
    handlePageChange_upcoming (value) {
      this.page_upcoming = value
      this.getAllMeetings()
    },
    handlePageChange_previous (value) {
      this.page_previous = value
      this.getAllMeetings()
    },
    handlePageChange_cancel (value) {
      this.page_cancel = value
      this.getAllMeetings()
    },
    handlePageSizeChange_upcoming (size) {
      this.pageSize_upcoming = size
      this.getAllMeetings()
    },
    handlePageSizeChange_previous (size) {
      this.pageSize_previous = size
      this.getAllMeetings()
    },
    handlePageSizeChange_cancel (size) {
      this.pageSize_cancel = size
      this.getAllMeetings()
    }
  }
}
</script>
